import { IUserDetail } from '@types';
import { AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useQuery } from '@tanstack/react-query';

// 어드민 - 회원 수정 페이지: 회원 정보 불러오기
async function getUser(userId?: string): Promise<AxiosResponse<FetchResult<IUserDetail>>> {
  const response = await instance.get(`/users/${userId}`);
  return response;
}

const useFetchUser = (userId?: string) => {
  const { data: originalData, refetch } = useQuery({
    queryKey: ['get', `/users/${userId}`],
    queryFn: () => getUser(userId),
    retry: false,
    refetchOnWindowFocus: false,
    enabled: Boolean(userId)
  });

  const response = originalData?.data;

  return { response, refetch };
};

export default useFetchUser;
